export default {
  perfumes: {
    en: 'perfumes',
  },
  colognes: {
    en: 'colognes',
  },
  fragrance: {
    en: 'fragrance',
  },
  category: {
    en: '{gender, select, female {perfume} male {cologne}}',
  },
  bestSelling: {
    en: 'Best selling {category}',
  },
  newArrivals: {
    en: 'New arrivals',
  },
}
